import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { T682Z } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class T682ZRepository extends RepositoryBase<T682Z> {
  protected readonly KEY_PATH = 't682z';
}
